import * as React from 'react';
import { useEffect, useState } from 'react';
import { addDays, addMonths, format, getDate, isBefore, isSameMonth, isToday, isWithinInterval, startOfWeek, } from 'date-fns';
import { compose } from 'recompose';
import { createStyles, Grid, Paper, Typography } from '@material-ui/core';
import { chunks, getDaysInMonth, inDateRange, isEndOfRange, isRangeSameDay, isStartOfRange } from '../../utils';
import Header from '../DateRangePickerComponentHeader';
import Day from '../DateRangePickerComponentDay/DateRangePickerComponentDay';
import { MARKERS, NavigationAction } from '../../types';
import { border } from '@topconagriculture/theme';
import { withBaseProps } from '../../../../Utils';
import defaultLocale from 'date-fns/locale/en-US';
const styles = (theme) => createStyles({
    root: {
        width: 290,
    },
    weekDaysContainer: {
        marginTop: theme.space.margin.small,
        paddingLeft: theme.space.padding.large,
        paddingRight: theme.space.padding.large,
        fontSize: theme.font.size.mediumSmall,
    },
    daysContainer: {
        paddingLeft: theme.space.padding.small,
        paddingRight: theme.space.padding.small,
        marginTop: theme.space.margin.small,
        marginBottom: theme.space.margin.default,
    },
    divider: {
        borderBottom: border(theme.color.grey.lightest, 2, 'solid'),
        width: '80%',
        margin: 'auto',
    },
});
const DateRangePickerComponentMonth = (props) => {
    const { classes, handlers, value: date, dateRange, marker, setValue: setDate, minDate, maxDate, navState, disableSelectMonthDropdown, dateFormat, locale: localeCode, weekStartsOn, maxRangeInMonths, } = props;
    const [locale, setLocale] = useState(defaultLocale);
    useEffect(() => {
        async function loadLocale(localeIdentifier) {
            switch (localeIdentifier) {
                case 'en':
                    setLocale(defaultLocale);
                    break;
                default:
                    try {
                        const data = await import(`date-fns/locale/${localeIdentifier}/index.js`);
                        setLocale(data);
                    }
                    catch (e) {
                        setLocale(defaultLocale);
                    }
                    break;
            }
        }
        loadLocale(localeCode);
    }, [localeCode, setLocale]);
    const weekdaysArray = Array.from(Array(7).keys()).map((day) => format(addDays(startOfWeek(date, { weekStartsOn }), day), 'EEEEEE', { locale }));
    const [back, forward] = navState;
    return (React.createElement(Paper, { square: true, elevation: 0, className: classes.root },
        React.createElement(Grid, { container: true },
            React.createElement(Header, { disableDropdown: disableSelectMonthDropdown, date: date, setDate: setDate, nextDisabled: !forward, prevDisabled: !back, onClickPrevious: () => handlers.onMonthNavigate(marker, NavigationAction.Previous), onClickNext: () => handlers.onMonthNavigate(marker, NavigationAction.Next), locale: locale }),
            React.createElement(Grid, { item: true, container: true, direction: "row", justifyContent: "space-between", className: classes.weekDaysContainer }, weekdaysArray.map((day) => (React.createElement(Typography, { color: "textPrimary", key: day, variant: "inherit" }, day)))),
            React.createElement("div", { className: classes.divider }),
            React.createElement(Grid, { item: true, container: true, direction: "column", justifyContent: "space-between", className: classes.daysContainer }, chunks(getDaysInMonth(date, weekStartsOn), 7).map((week, idx) => (React.createElement(Grid, { key: idx, container: true, direction: "row", justifyContent: "center" }, week.map((day) => {
                const isSecondMonth = marker === MARKERS.SECOND_MONTH;
                const isStart = marker === MARKERS.FIRST_MONTH && isStartOfRange(dateRange, day);
                const isEnd = isSecondMonth && isEndOfRange(dateRange, day);
                const isRangeOneDay = isRangeSameDay(dateRange);
                const highlighted = inDateRange(dateRange, day);
                const isEarlierThanStart = dateRange.startDate && isBefore(day, dateRange.startDate);
                const isNotInMaxRange = !!maxRangeInMonths &&
                    dateRange.startDate &&
                    !isWithinInterval(day, {
                        start: dateRange.startDate,
                        end: addMonths(dateRange.startDate, maxRangeInMonths),
                    });
                return (React.createElement(Day, { key: format(day, dateFormat), filled: isStart || isEnd, outlined: marker === MARKERS.FIRST_MONTH && isToday(day), highlighted: highlighted && !isRangeOneDay, isSameMonth: isSameMonth(date, day), isNotInRange: !isWithinInterval(day, { start: minDate, end: maxDate }) ||
                        isNotInMaxRange ||
                        (isSecondMonth && isEarlierThanStart), startOfRange: isStart && !isRangeOneDay, endOfRange: isEnd && !isRangeOneDay, onClick: () => handlers.onDayClick(marker, day), value: getDate(day) }));
            }))))))));
};
export default compose(withBaseProps({ styles }))(DateRangePickerComponentMonth);
//# sourceMappingURL=DateRangePickerComponentMonth.js.map